








import { Component, Prop, Vue } from 'vue-property-decorator';
import FailureModeTabDialog from '../NewSettings/NewAssets/FailureMode/FailureModeTabDialog.vue';
import FailureModeGrid from '../NewSettings/NewAssets/FailureMode/FailureModeGrid.vue';

@Component<FailureModeTab>({
    components: {
        'failure-mode-tab-dialog': FailureModeTabDialog,
        'failure-mode-grid': FailureModeGrid,
    }
})
export default class FailureModeTab extends Vue {

    @Prop({ required: true }) workOrderId!: string;

    async reserveApproved() {
        await this.$nextTick();
        const dialog = this.$refs.failureModeTabDialog as FailureModeTabDialog;
        await dialog.loadLists();
        dialog.showDialog();
    }

    async onEditRecord(id: number) {
        await this.$nextTick();
        const dialog = this.$refs.failureModeTabDialog as any;
        await dialog.loadRecord(id);
        dialog.showDialog();
    }

    onDialogClose() {
        this.$eventHub.$emit('failureModeAdded');
    }
}
